import { io, Socket } from 'socket.io-client';

import { environmentVars } from './variables/environment';

let socket: Socket | null = null;

const getSocket = (): Socket | null => {
	if (!socket && environmentVars.biTec.environment === 'production') {
		socket = io(environmentVars.biTec.url ?? '', {
			transports: ['websocket', 'polling'],
		});
	}
	return socket;
};

const addWebSocketListener = (
	customerId: string,
	handler: (data: any) => void
) => {
	try {
		const socketInstance = getSocket();
		if (!socketInstance) return;
		const bistoreResult = (data: any) => {
			handler(data);
		};

		socketInstance.on(`bibotStatusChanged:${customerId}`, bistoreResult);
	} catch (error) {
		console.error('Erro ao iniciar o websocket:', error);
	}
};

const removeWebSocketListener = (
	customerId: string,
	handler: (data: any) => void
) => {
	try {
		if (!socket) return;
		socket.off(`bibotStatusChanged:${customerId}`, handler);
	} catch (error) {
		console.error('Erro ao finalizar o websocket:', error);
	}
};

export { addWebSocketListener, removeWebSocketListener };
